import { Image } from "antd";
import React, { useContext, useEffect, useState } from "react";
// import { Card, Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { MOB_ICONS, getFileLiveUrl, upperCase, yearBySem } from "../../utils";
import { useNavigate } from "react-router-dom";
import { ServiceUrl } from "../../utils/serviceUrl";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import SkipNextIcon from "@mui/icons-material/SkipNext";

const WelcomeProfile = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState([]);
  const linkClick = (toUrl) => {
    navigate(toUrl);
  };

  const userPhoto = () => {
    let gender = upperCase(context.user.gender);
    let path = context.user.profile_photo;
    if (path && path.length > 5) {
      return getFileLiveUrl(path);
    }

    if (gender == "MALE") return MOB_ICONS.MAN_256;
    else if (gender == "FEMALE") return MOB_ICONS.WOMAN_256;
    return MOB_ICONS.NO_USER_250;
  };

  /*  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    const form = new FormData();
    form.append("type", "student");
    form.append("uuid", context.user.uuid);
    form.append("course", context.user.course);
    axios.post(ServiceUrl.STUDENTS.MY_NOTIFICATION_COUNT, form).then((res) => {
      if (res["data"].status == "1") {
        if (parseInt(res["data"].data.history_count) > 0) {
          setNotificationCount(
            parseInt(res["data"].data.count) -
              parseInt(res["data"].data.history_count)
          );
        } else {
          setNotificationCount(parseInt(res["data"].data.count));
        }
      } else {
      }
      //  setLoader(false);
    });
  }; */

  return (
    <>
      <Card sx={{ display: "flex" }} className="card-header-bg">
        <CardMedia component="img" sx={{ width: 120 }} src={userPhoto()} />

        <Box sx={{ display: "flex", flexDirection: "column" }} className="ms-2">
          <CardContent sx={{ flex: "1 0 auto" }}>
            <Typography
              component="div"
              variant="h5"
              className="fw-bolder"
              style={{ fontSize: "16px" }}
            >
              {context.user.name} {context.user.initial}
            </Typography>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{ color: "black" }}
            >
              {context.user.registerno || context.user.admissionno}
            </Typography>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{ color: "black", fontSize: "12px" }}
            >
              {yearBySem(context.user.semester)}-{context.user.degree_name}{" "}
              {context.user.course_name}
            </Typography>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{ color: "black", fontSize: "12px" }}
            >
              Semester - {context.user.semester}
            </Typography>
          </CardContent>
        </Box>
      </Card>
      {/* <Card className="mb-3" data-aos="zoom-in">
        <Card.Body>
          <Row className="">
            <Col md={2} xs={3} sm={3} data-aos="fade-up">
          
              <Image
                src={userPhoto()}
                fallback={MOB_ICONS.NO_USER_250}
                preview={false}
                className="rounded w-100"
                style={{ maxHeight: "80px" }}
              />
            </Col>
            <Col md={10} xs={9} sm={9}>
              <h5
                data-aos="fade-up"
                style={{ fontSize: "16px", color: "#a31a04" }}
              >
                {context.user.name} {context.user.initial}
              </h5>{" "}
              <a onClick={(e) => linkClick("/stu/app/notification")}>
                <div class="stu-notification-container">
                  <img
                    src={MOB_ICONS.BELL}
                    style={{ width: "37px" }}
                    class="notification-icon"
                    alt="Notification Icon"
                  />
                  {notificationCount > 0 ? (
                    <>
                      <span class="stu-notification-count">
                        {notificationCount}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>{" "}
              </a>
              <div
                className=""
                style={{ fontSize: "13px", marginTop: "-20px" }}
                data-aos="fade-up"
              >
                <i className="fa-solid fa-id-badge"></i>
                <span className="ms-2 me-2">
                  {context.user.registerno || context.user.admission_no}
                </span>
                <div className="d-block d-sm-none"></div>
                <i className="fa-solid fa-graduation-cap"></i>
                <span className="ms-2 ">
                  {yearBySem(context.user.semester)}
                  {" - "}
                  {context.user.degree_name} {context.user.course_name}
                </span>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card> */}
    </>
  );
};
export default WelcomeProfile;
